import { connect } from 'react-redux';
import { PushToGoogleCalendar } from '../../components/PushToGoogleCalendar/PushToGoogleCalendar';
import { IPushToGoogleCalendarEvents, IPushToGoogleCalendarFields } from '../../components/PushToGoogleCalendar/types';
import { onOpen } from './events/onOpen';
import { onDidMount } from './events/onDidMount';
import { IPushToGoogleCalendarHOCProps } from './types';
import { getAppState } from 'app/store/configureStore';
import { IApplicationState } from 'app/types/types';
import { showBoardLimitSnackbarIfNeeded } from '../../../../effects/showBoardLimitSnackbarIfNeeded';
import { getSectionType } from '../../../selectors/getSectionType';
import { getBoardIdByCardId } from '../../../../../../../store/model/selectors/getBoardIdByCardId';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import { getCardCalendarDateEvents } from '../../../../../../../store/model/selectors/getCardCalendarDateEvents';
import {
    getUserCommentsColumnView
} from '../../../../../../../store/model/authUser/selectors/getUserCommentsColumnView';

const mapStateToProps = (
    state: IApplicationState,
    ownProps: IPushToGoogleCalendarHOCProps
): IPushToGoogleCalendarFields => {
    const {cardId } = ownProps;
    const calendarEvents = getCardCalendarDateEvents(getAppState(), cardId);
    const sectionType = getSectionType(state, getBoardIdByCardId(state, cardId), cardId);
    return {
        isColumnView: getUserCommentsColumnView(state),
        isDatePushed: calendarEvents.length > 0,
        isReadonly: sectionType === ESettingsSectionType.READONLY,
    }
};
const mapDispatchToProps = (
    dispatch: any,
    {cardId}: IPushToGoogleCalendarHOCProps
): IPushToGoogleCalendarEvents => {
    return {
        onOpen: () => dispatch(onOpen()),
        onDidMount: () => dispatch(onDidMount(cardId)),
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
    }
};

export const PushToGoogleCalendarHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(PushToGoogleCalendar);

PushToGoogleCalendarHOC.displayName = 'PushToGoogleCalendarHOC';
